import React, { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { ConfirmationOfApplication, PlaceOfResidencePreview } from '@/features/ui';
import { AdditionalDocumentsPreview } from '@/features/ui/Steps/AdditionalDocuments/AdditionalDocuments';
import { useProceedNextFromConfirmation } from '@/features/ui/Steps/ConfirmationOfApplication/utils/useProceedNextFromConfirmation';
import { HealthDataPreview } from '@/features/ui/Steps/HealthData/HealthData';
import { LearningDocumentPreview } from '@/features/ui/Steps/LearningDocument/LearningDocument';
import { PersonalAndPassportDataPreview } from '@/features/ui/Steps/PersonalAndPassportData';

import { ConditionView, Loader, StepControlPanel } from '@/shared/ui';

import { WeaponPurchasePermitMergedSchema } from '../../model/types';

import { ObjectOfPurchasePreview } from './ObjectOfPurchase';
import { PersonStatusPreview } from './PersonStatus';

export interface DataPreviewProps {
  handleGeneratePDF: (formData: WeaponPurchasePermitMergedSchema) => Promise<void>;
}

export const DataPreview: React.FC<StepProps<DataPreviewProps>> = ({ next, prev, handleGeneratePDF }) => {
  const { getValues, control } = useFormContext<WeaponPurchasePermitMergedSchema>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { proceedNextFromConfirmation } = useProceedNextFromConfirmation(next);

  const confirmEnteredDataCorrect = useWatch({
    control,
    name: 'confirmEnteredDataCorrect',
  });

  const handleNextStep = (): void => {
    setIsLoading(true);

    handleGeneratePDF(getValues())
      .then(proceedNextFromConfirmation)
      .catch(console.error)
      .finally(() => setIsLoading(false));
  };

  return (
    <ConditionView if={!isLoading} else={<Loader />}>
      <FormBlock title="Підтвердження даних">
        <ObjectOfPurchasePreview />
        <PersonStatusPreview />
        <LearningDocumentPreview />
        <HealthDataPreview />
        <PersonalAndPassportDataPreview />
        <PlaceOfResidencePreview />
        <AdditionalDocumentsPreview />
      </FormBlock>
      <ConfirmationOfApplication />
      <StepControlPanel prev={prev} next={handleNextStep} disabledNext={!confirmEnteredDataCorrect} />
    </ConditionView>
  );
};
